import React from 'react';
import './../faq.scss';
import { Panel } from 'rsuite';

const FAQ = () => {

  return (
    <>
      <div className='faq'>
        <h1 className='faq-header'>
          Frequently Asked Questions
        </h1>
        <div className='faq-container'>
          <div className='faq-subheader'>
            <h3 className='subheader-title'>General</h3>
            <div>
              <Panel header="What is EE PASS?" collapsible bordered aria-expanded>
                <p>EE PASS gives educators 24/7 access to individualized training, certification tools, and real-time support designed to improve instruction and evaluation.</p>
                <p>Developed by NIET’s team of education professionals—with decades of on-the-ground experience supporting thousands of schools nationwide—EE PASS is your one-stop platform for professional learning and growth.</p>
                <p>As part of NIET’s comprehensive system of support for districts and schools, EE PASS extends professional learning, deepens instructional knowledge, and builds more consistent coaching across classrooms and schools.</p>
              </Panel>
              <Panel header="What is EE PASS Enhanced Search?" collapsible bordered aria-expanded>
                Enhanced Search allows educators and team leaders to quickly locate high-quality content within EE PASS Content Library. 
                It is a closed-source tool that produces results from resources within EE PASS Content Library only. By typing in a natural-language 
                question or topic, Enhanced Search provides relevant resources such as classroom lesson examples, instructional tools and rubrics, observation, feedback, or coaching strategies.
              </Panel>
            </div>
          </div>

          <div className='faq-subheader'>
            <h3 className='subheader-title'>Service & Support</h3>
            <div>
              {/* <Panel header="Can I access EE PASS from a mobile device?" collapsible bordered aria-expanded aria-selected="true">
                Yes, you can access EE PASS from a mobile device using an updated web browser application.
              </Panel> */}
              <Panel header="Who do I contact for technical support?" collapsible bordered aria-expanded>
                Email <a href="mailto:support@niet.org?subject=EEPASS v2 Technical Support">support@niet.org</a>, call 1-800-575-NIET or click the Contact Us button at the bottom right corner of the EE PASS website.
              </Panel>
              <Panel header="How do I reset my password?" collapsible bordered aria-expanded>
                To reset your password, click the Forgot Password link and follow the prompts on screen to verify your email address and process a verification code. For assistance, contact support@niet.org.
              </Panel>
              <Panel header="What can I do to prepare my system to access EE PASS?" collapsible bordered aria-expanded>
                  <p>Google Chrome and Microsoft Edge are our most compatible web browsers, so use one of these if possible. (If you don’t have access to update your browser, please follow up with your system administrator.)</p>
                  <p>Ensure that you are connected to a wi-fi network that has good speed.</p>
                  <p>Pop-ups must be enabled on your web browser to view certain resources.</p>
                  <p>Be sure your browser's zoom is set to 100% or below. The recommended display resolution for your device is 1920 x 1080 with zoom set to 100% or below.</p>
              </Panel>
              {/* <Panel header="How do I update my profile?" collapsible bordered aria-expanded>
              Once you are logged into EE PASS you can update your profile picture and information by click on Your Name > Profile. When you access your profile you can change the following: user profile picture, name, email, phone number, password, configure multi-factor authentication settings and update your content preferences.
              </Panel> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQ;